/**
 * MarcaVeiculo
 * @author gil
 */
export enum MarcaVeiculo {
  CHEVROLET = 'CHEVROLET',
  FIAT = 'FIAT',
  FORD = 'FORD',
  HONDA = 'HONDA',
  HYUNDAI = 'HYUNDAI',
  IVECO = 'IVECO',
  MAN = 'MAN',
  MERCEDES = 'ENZ',
  PEUGEOT = 'PEUGEOT',
  RENAULT = 'RENAULT',
  SCANIA = 'SCANIA',
  TOYOTA = 'TOYOTA',
  VOLKSWAGEN = 'VOLKSWAGEN',
  VOLVO = 'VOLVO',
  YAMAHA = 'YAMAHA',
  OUTROS = 'OUTROS',
}
